type Props = {
  isDarkMode: boolean;
};

export default function EnterIcon({ isDarkMode }: Props) {
  return (
    <svg width="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19,6a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H7.41l1.3-1.29A1,1,0,0,0,7.29,9.29l-3,3a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l3,3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L7.41,14H17a3,3,0,0,0,3-3V7A1,1,0,0,0,19,6Z"
        fill={isDarkMode ? "#ffffff" : "#000000"}
      />
    </svg>
  );
}
